export default __webpack_public_path__ + "static/media/mob-login.f61de525.png";